<template lang="html">
  <div id="job-description-page" >

    <section class="company-header-section" v-bind:style="{ backgroundImage: 'url('+company.empresa_imageUrl+')' }" style="background-color:gray !important">
      <div class="container" >
        <div class="row">

          <div class="col col-company-logo" >
            <div class="box">
              <div class="img"><img :src="company.imageUrl"></div>
            </div>
          </div>

          <div class="col col-company-info">
            <h1 class="company" style="font-family:sans-serif !important">{{company.nombre}}</h1>

            <div class="box-score">
              <span class="score" style="cursor: pointer;" @click="toReviews">{{company.calification_general}} <i class="fas fa-star"></i></span>
              <span style="cursor: pointer;" @click="toReviews">{{company.califications.length}} reviews</span>
            </div>

            <h5 class="location"><i class="icon"></i>{{company.domicilio}}, {{company.ciudad}}, {{company.estado}}.</h5>
            <!-- <a class="trans-250 btn-map" target="_blank" href="https://g.page/insumosquirurgicos?share">abrir mapa</a> -->
            <a class="trans-250 btn-map" target="_blank" :href="company.url_maps">Abrir mapa</a>

            <div class="box-contact">
              <span><a target="_blank" :href="company.sitio_web">{{company.sitio_web}}</a></span>
              <span><a target="_blank" :href="'mailto:'+company.email"><i class="fas fa-envelope"></i> {{company.email}}</a></span>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="container extra-options-section">
      <div class="box-score">
        <span><button class="btn-squ-cur-1 post" style="border: #ffb607;" @click="toFormCalification">Publicar Opinión</button></span>
        <span @click="followCompany" ><a class="btn-squ-cur-1 follow">Seguir</a></span>
 

        <span style="float: right;" v-if="company.mejoresempresas == 1"><button class="btn-squ-cur-1 post" style="border: rgb(255, 182, 7);"><i class="fas fa-star"></i><br> Mejores empresas</button></span>
      </div>

      <div class="box-networks">
        <span>Visitar perfil de</span>

        <a class="trans-250 link-network fb" :href="company.facebook"><i class="fab fa-facebook-f"></i></a>
        <a class="trans-250 link-network tw" :href="company.instagram"><i class="fab fa-twitter"></i></a>
        <a class="trans-250 link-network lk" :href="company.linkedin"><i class="fab fa-linkedin"></i></a>
      </div>
    </section>

    <section class="container job-description-section">
      <div class="row">

        <!-- Description -->
        <div class="col-lg-8 col-xl-9 col-main-info">
          <div class="content">
            <div class="box-top">
              <div class="col col-info" style="cursor: pointer;" @click="$router.push('/empresas/empleos/'+id)">
                <h5 class="m-title">Vacantes Activas</h5>
                <h5 class="res">{{company.vacantes_total}}</h5>
              </div>

              <div class="col col-info">
                <h5 class="m-title">Sector</h5>
                <h5 class="res" v-for="(category,indx) in company.categorias" :key="category">{{category.nombre}}</h5>
              </div>

              <div class="col col-info">
                <h5 class="m-title">Visitas</h5>
                <h5 class="res">{{company.web_views}}</h5>
              </div>
            </div>

            <div class="box-description">
              <h5 class="m-title">Descripción de la Empresa</h5>
              <div>
                <p v-html="company.descripcion"></p>
              </div>

              <h5 class="m-title mt-3">Valores</h5>
              <ul class="check-list">
                <p v-html="company.valores"></p>
              </ul>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- Sidebar -->
        <div class="col-lg-4 col-xl-3 col-contact-form">
          <div class="box-el-title">
            <h3>Formulario de contacto</h3>
          </div>

          <b-form @submit="onSubmitContact">
            <b-form-group label="Nombre:" label-for="i-1">
              <b-form-input
                id="i-1"
                v-model="contactForm.name"
                type="text"
                placeholder="Ingresa tu nombre"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Correo Electrónico:" label-for="i-2">
              <b-form-input
                id="i-2"
                v-model="contactForm.email"
                type="email"
                placeholder="Ingresa tu correo electrónico"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Número Telefónico:" label-for="i-3">
              <b-form-input
                id="i-3"
                v-model="contactForm.phone"
                type="text"
                placeholder="Ingresa tu número telefónico"
                maxlength="10"
                minlength="10"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Mensaje:" label-for="i-4">
              <b-form-textarea
                id="i-4"
                v-model="contactForm.msg"
                placeholder="Escriba el mensaje aquí"
                rows="5"
                max-rows="5"
              ></b-form-textarea>
            </b-form-group>

            <p>
              <b-form-checkbox
                v-model="contactForm.checkbox"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                required>
                Al hacer clic en la casilla de verificación, acepta nuestros Términos y condiciones y Política de privacidad
              </b-form-checkbox>
            </p>

            <p class="mt-3">
              <b-button type="submit" class="btn-squ-cur-1 xl blue w-100">ENVIAR MENSAJE</b-button>
            </p>
          </b-form>
        </div>
        <!--  -->

      </div>
    </section>

    <section class="container comments-form-section" id="form_califications">
      <div class="box-el-title">
        <h3>Deja tu opinión</h3>
      </div>

      <div class="row">
        <div class="col-lg-8 col-xl-9 content">
          <b-form class="box-form-comment" @submit="onSubmit">

            <div class="box-form-group-1">
              <div class="row align-items-center">
                <div class="col-sm-6 col-md-7 col-stars">
                  <div class="box-category">
                    <label for="rating-inline">Calificación</label>
                    <b-form-rating id="rating-inline" inline v-model="formRating.calification"></b-form-rating>
                  </div>

                  <!--div class="box-category">
                    <label for="rating-inline">Trato al personal</label>
                    <b-form-rating id="rating-inline" inline v-model="formRating.trato"></b-form-rating>
                  </div>

                  <div class="box-category">
                    <label for="rating-inline">Compromiso</label>
                    <b-form-rating id="rating-inline" inline v-model="formRating.compromiso"></b-form-rating>
                  </div-->
                </div>

                <div class="col-sm-6 col-md-5 col-score">
                  <h6>Calificación General</h6>
                  <h3>{{formRating.calification}}</h3>
                </div>
              </div>
            </div>

            <div class="box-form-group-2">
              <b-form-group>
                <b-form-textarea
                  v-model="formRating.msg"
                  placeholder="Tu experiencia con la empresa"
                  rows="4"
                  max-rows="4"
                  required
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="box-form-group-3">
              <b-button type="submit" class="btn-squ-cur-1 lg blue">Comentar</b-button>
            </div>

          </b-form>
        </div>
      </div>
    </section>


    <section class="container comments-section" id="calification_company">
      <div class="box-el-title">
        <h3>Opiniones</h3>
      </div>

      <div class="row">
        <div class="col-lg-8 col-xl-9 content">
          <div class="box-comment-sample-s1" v-for="(calification, indxc) in company.califications" :key="indxc">
            <div class="col col-photo">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+calification.usuario_image+')' }"></div>
            </div>

            <div class="col col-info">
              <div class="box-date">{{calification.fecha}}</div>
              <h4>{{calification.usuario}}</h4>

              <div class="box-stars" v-if="calification.calificacion == 5">
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
              </div>
              <div class="box-stars" v-else-if="calification.calificacion == 4">
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
              </div>
              <div class="box-stars" v-else-if="calification.calificacion == 3">
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
              </div>
              <div class="box-stars" v-else-if="calification.calificacion == 2">
                <i class="fas fa-star star"></i>
                <i class="fas fa-star star"></i>
              </div>
              <div class="box-stars" v-else-if="calification.calificacion == 1">
                <i class="fas fa-star star"></i>
              </div>

              <div class="box-descr">
                {{calification.msg}}
              </div>
              <div class="box-descr" v-if="calification.respuesta != null">
                <b>- Respuesta: </b> {{calification.respuesta}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <sweet-modal :icon="modal.icon" ref="modalAlert">
          {{modal.msg}}
      </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      contactForm: {

      },

      formRating: {
        calification:0,
        msg:null,
        company_id:null
      },
       company:{

        },
        id:"",

      modal:{
          icon:null,
          msg:null
      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.$root.logged == true) {
          if (this.$root.type_logged == 'usuario') {
              this.formRating.company_id = this.id;
              this.formRating.user_id = this.$root.user.usuarios_id;
              axios.post(tools.url("/companyFrontStoreCalification"),this.formRating)
                .then((response)=>{
                      this.formRating.calification = 0;
                      this.formRating.msg = null;

                      this.modal.icon = 'success'
                      this.modal.msg = 'Calificación guardada con exito';
                      this.$refs.modalAlert.open();
                      
                  }).catch((error)=>{
                      this.modal.icon = 'error'
                      this.modal.msg = 'Ocurrio un error al guardar';
                      this.$refs.modalAlert.open();
                  });
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes dejar comentarios hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      }
      else{
        this.modal.icon = 'warning';
        this.modal.msg = 'No puedes dejar comentarios hasta estar registrado o haber iniciado sesion';
        this.$refs.modalAlert.open();
      }

      
    },
    onSubmitContact(event){
       event.preventDefault();
       if (this.$root.logged == true) {
          if (this.$root.type_logged == 'usuario') {
            this.contactForm.company_id = this.id;
            this.contactForm.user_id = this.$root.user.usuarios_id;
            axios.post(tools.url("/companyFrontStoreMsg"),this.contactForm)
              .then((response)=>{
                    this.contactForm = {};

                    this.modal.icon = 'success'
                    this.modal.msg = 'Gracias, su mensaje ha sido enviado!';
                    this.$refs.modalAlert.open();
                }).catch((error)=>{
                    this.modal.icon = 'error'
                    this.modal.msg = 'Ocurrio un error al guardar!';
                    this.$refs.modalAlert.open();
                });
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes contactar a la empresa hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      }
      else{
        this.modal.icon = 'warning';
        this.modal.msg = 'No puedes contactar a la empresa hasta estar registrado o haber iniciado sesion';
        this.$refs.modalAlert.open();
      }
    },

    getData(){

      axios.get(tools.url("/companyFront/"+this.id))
        .then((response)=>{
            this.company = response.data;
          }).catch((error)=>{
            this.$parent.handleErrors(error);
          });
    },
    storeView(){
      axios.get(tools.url("/companyStoreViewFront/"+this.id))
        .then((response)=>{

      }).catch((error)=>{

      });
    },
    toFormCalification(){
        var tablePosY = document.getElementById("form_califications").offsetTop
        setTimeout( ()=>{
          window.scrollTo({ top: tablePosY, left: 0, behavior: 'smooth' });
        }, 200);
    },
    toReviews(){
        var tablePosY = document.getElementById("calification_company").offsetTop
        setTimeout( ()=>{
          window.scrollTo({ top: tablePosY, left: 0, behavior: 'smooth' });
        }, 200);
    },
    followCompany(){
        event.preventDefault();
      if (this.$root.logged == true) {
          if (this.$root.type_logged == 'usuario') {
              this.formRating.company_id = this.id;
              this.formRating.user_id = this.$root.user.usuarios_id;
              axios.post(tools.url("/followCompany"),this.formRating)
                .then((response)=>{
                      
                      this.modal.icon = 'success'
                      this.modal.msg = 'Has empezado a seguir la empresa';
                      this.$refs.modalAlert.open();
                      
                  }).catch((error)=>{
                      this.modal.icon = 'error'
                      this.modal.msg = 'Ocurrio un error al guardar';
                      this.$refs.modalAlert.open();
                  });
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes seguir a una empresa hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      }
      else{
        this.modal.icon = 'warning';
        this.modal.msg = 'No puedes seguir a una empresa hasta estar registrado o haber iniciado sesion';
        this.$refs.modalAlert.open();
      }
    }
  },
   mounted(){

      if(this.$route.params.id){
        this.id = this.$root._getURLID(this.$route.params.id);
        this.getData();
        this.storeView();
      }

    }
}
</script>
